/** Next classroom intake — 10:00 AM IST, 14 days from first render of the week. */
export function getNextBatchStart(): Date {
  const now = new Date();
  const start = new Date(now);
  start.setDate(start.getDate() + 14);
  start.setHours(10, 0, 0, 0);
  return start;
}

export function formatBatchDate(date: Date): string {
  return date.toLocaleDateString("en-IN", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

export function formatBatchTime(date: Date): string {
  return date.toLocaleTimeString("en-IN", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

export type BatchCountdown = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  totalMs: number;
};

export function getBatchCountdown(target: Date, now = new Date()): BatchCountdown {
  const totalMs = Math.max(0, target.getTime() - now.getTime());
  const totalSec = Math.floor(totalMs / 1000);

  return {
    days: Math.floor(totalSec / 86400),
    hours: Math.floor((totalSec % 86400) / 3600),
    minutes: Math.floor((totalSec % 3600) / 60),
    seconds: totalSec % 60,
    totalMs,
  };
}
